import Layout from '../../internal/Layout.vue'
import StandardManufacturerPage from './index.vue'

const StandardManufacturerRoutes = {
  component: Layout,
  children: [
    {
      name: 'StandardManufacturer',
      path: '/',
      component: StandardManufacturerPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
      },
    },
  ],
}

export default StandardManufacturerRoutes
